import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./Wishlist.css";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const WISHLIST_API = `${API_BASE_URL}/api/wishlist`;
const FALLBACK_IMAGE = "https://via.placeholder.com/300x300?text=No+Image";

const Wishlist = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    fetchWishlist();
  }, []);

  const resolveImageUrl = (img) => {
    if (!img || String(img).trim() === "") return FALLBACK_IMAGE;
    if (img.startsWith("http://") || img.startsWith("https://")) return img;
    if (img.startsWith("/uploads")) return `${API_BASE_URL}${img}`;
    if (img.startsWith("uploads/")) return `${API_BASE_URL}/${img}`;
    return `${API_BASE_URL}/uploads/${img}`;
  };

  const getProductImage = (product) => {
    if (product?.image && String(product.image).trim() !== "") {
      return resolveImageUrl(product.image);
    }

    if (
      Array.isArray(product?.images) &&
      product.images.length > 0 &&
      product.images[0]
    ) {
      return resolveImageUrl(product.images[0]);
    }

    return FALLBACK_IMAGE;
  };

  const fetchWishlist = async () => {
    try {
      setLoading(true);

      const res = await axios.get(WISHLIST_API, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setWishlistItems(res.data?.wishlist || []);
    } catch (error) {
      console.log(error);
      setWishlistItems([]);
    } finally {
      setLoading(false);
    }
  };

  const removeFromWishlist = async (productId) => {
    try {
      await axios.delete(`${WISHLIST_API}/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setWishlistItems((prev) =>
        prev.filter((item) => (item.product?._id || item.product?.id) !== productId)
      );
    } catch (error) {
      console.log(error);
      alert(error.response?.data?.message || "Failed to remove item");
    }
  };

  if (loading) {
    return (
      <div className="wishlist-page">
        <div className="page-banner">
          <h1>My Wishlist</h1>
        </div>

        <div className="container">
          <div className="loading-box">
            <h2>Loading Wishlist...</h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div className="page-banner">
        <h1>My Wishlist</h1>
        <p>Your saved products in one place</p>
      </div>

      <div className="container wishlist-grid">
        {wishlistItems.length === 0 ? (
          <div className="loading-box">
            <h2>No wishlist items found.</h2>
          </div>
        ) : (
          wishlistItems.map((item) => {
            const product = item.product;
            if (!product) return null;

            return (
              <div className="wishlist-card" key={item._id}>
                <img
                  src={getProductImage(product)}
                  alt={product.name}
                />

                <h3>{product.name}</h3>
                <p>₹{product.price}</p>

                <div className="wishlist-actions">
                  <Link to={`/product/${product._id || product.id}`}>
                    <button className="view-btn">View Product</button>
                  </Link>

                  <button
                    className="remove-btn"
                    onClick={() => removeFromWishlist(product._id || product.id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Wishlist;